import React from "react";
import "./header.scss";
import { useHistory } from "react-router-dom";

const Header = () => {
  const history = useHistory();

  const handleLogout = () => {
    localStorage.removeItem("authPassword"); // 🔷 clear password
    history.push("/login"); // 🔷 redirect to login
  };

  return (
    <>
      <section className="main-navbar">
        <div className="custom-container">
          <nav className="navbar navbar-expand-lg">
            <a className="navbar-brand" href="/">
              <img src="/logo.svg" alt="img" className="img-fluid" />
            </a>
            <button className="btn-logout" onClick={handleLogout}>
              LOG OUT
            </button>
          </nav>
        </div>
      </section>
    </>
  );
};

export default Header;
